/** @format */

import React, { useEffect, useState, useCallback } from "react";
import { Drawer } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isAuthenticated, LOGOUT } from "../../store/authSlice";
import { openQuiz } from "../../store/quizSlice";
import AcneQuiz from "../AcneQuiz/AcneQuiz";
import { getProfile, getApi } from "../../Repository/Api";
import { AiOutlineClose } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import endPoints from "../../Repository/apiConfig";
import { ImageLazyLoading } from "../../utils/helpingComponent";

const Sidebar = ({ open, onClose }) => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({});
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [openSubSubmenu, setOpenSubSubmenu] = useState(null);
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [services, setServices] = useState([]);
  const [load, setLoad] = useState(false);
  const isLoggedIn = useSelector(isAuthenticated);
  const dispatch = useDispatch();
  const { isQuizOpen } = useSelector((store) => store.quiz);

  const navigationHandler = (link) => {
    onClose();
    navigate(link);
  };

  function LogoutHandler() {
    onClose();
    dispatch(LOGOUT());
    navigate("/login");
  }

  function fetchProfile() {
    getProfile(setProfile);
  }

  const fetchCategories = useCallback(() => {
    getApi({
      url: endPoints.service.getCategory,
      setResponse: setCategory,
      setLoading: setLoad,
    });
  }, []);

  const fetchServices = useCallback(() => {
    const queryParams = new URLSearchParams({
      categoryId: categoryId,
    });

    const beforeLoginUrl = endPoints.service.getServiceByCategoryBeforeLogin(
      queryParams.toString()
    );
    const afterLoginUrl = endPoints.service.getServiceByCategoryAfterLogin(
      queryParams.toString()
    );
    const url = isLoggedIn ? beforeLoginUrl : beforeLoginUrl;

    getApi({
      url: url,
      setLoading: setLoad,
      setResponse: setServices,
    });
  }, [categoryId, isLoggedIn]);

  useEffect(() => {
    if (open) {
      fetchProfile();
      fetchCategories();
    }
  }, [open, fetchCategories]);

  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  function getServicesByCategoryId(categoryId) {
    return services?.data?.docs?.filter(service =>
      service.categoryId && service.categoryId._id === categoryId
    ) || [];
  }

  function generateMenuItems() {
    const categoryItems = category?.data?.map(category => {
      const categoryServices = getServicesByCategoryId(category._id);

      return {
        label:category.name,
        link: "/services/services",
        key: category.name.toLowerCase().replace(/\s+/g, '-'),
        submenu: categoryServices.map((service, index) => ({
          label: service.name,
          key: `${category.name.toLowerCase().replace(/\s+/g, '-')}-${index + 1}`,
          link: `/service/${service.type}/${service.slug}`
        })),
      };
    }) || [];

    return [
      {
        link: "/",
        title: "HOME",
      },
      {
        link: "/shop",
        title: "SHOP",
      },
      {
        title: "SERVICES",
        link: "/services/services",
        submenu: [
          ...categoryItems,
          {
            label: <Link to="/limited-deals">Limited Time Offers</Link>,
            key: "limited-offers",
            link: "/limited-deals"
          }
        ]
      },
      {
        link: "/paymentplan",
        title: "PAYMENT PLANS",
      },
      {
        link: "/membership",
        title: "MEMBERSHIP",
      },
      {
        link: "/giftcards",
        title: "GIFT CARDS",
      },
      {
        link: "/checkIngredients",
        title: "CHECK INGREDIENTS",
      },
      {
        title: "ACNE QUIZ",
      },
      {
        link: "/gallery",
        title: "GALLERY",
      },
      {
        link: "/contact",
        title: "CONTACT",
      },
      {
        link: "/aboutus",
        title: "ABOUT US",
      },
    ];
  }

  const menuOptions = generateMenuItems();

  async function openQuizHandler() {
    await dispatch(openQuiz());
  }

  const toggleSubmenu = (title) => {
    setOpenSubmenu(openSubmenu === title ? null : title);
    setOpenSubSubmenu(null);
  };

  const toggleSubSubmenu = (key) => {
    setOpenSubSubmenu(openSubSubmenu === key ? null : key);
  };

  return (
    <Drawer
      placement="left"
      closable={false}
      onClose={onClose}
      open={open}
      className="sidebar"
    >
      <div className="Sidebar_Menu">
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <AiOutlineClose className="closeIcon" onClick={() => onClose()} />
        </div>
        {isLoggedIn === true && (
          <>
            <div className="profile_View">
              {profile?.image ? (
                <ImageLazyLoading
                  img={profile?.image}
                  alt={"Avatar"}
                  className={"text-[10px]"}
                />
              ) : (
                <ImageLazyLoading
                  img={
                    "https://img.freepik.com/premium-vector/human-symbol-3d-icon-user-business-symbology-website-profile_593228-130.jpg?w=2000"
                  }
                  alt={"Default Avatar"}
                  className={"text-[10px]"}
                />
              )}

              <div className="content">
                <p className="title">
                  {profile?.firstName + " " + profile?.lastName}{" "}
                </p>

                <p className="email"> {profile?.email} </p>

                <Link to="/my-profile" onClick={() => onClose()}>
                  VIEW PROFILE{" "}
                </Link>
              </div>
            </div>

            <div className="empty"></div>
          </>
        )}

        <ul>
          {menuOptions?.map((item, index) => (
            <li key={index}>
              {item.title === "ACNE QUIZ" ? (
                <span onClick={() => openQuizHandler()}>{item.title}</span>
              ) : item.title === "SERVICES" ? (
                <>
                  <div
                    className="menu-item flex-container"
                    onClick={() => toggleSubmenu(item.title)}
                  >
                    <span>{item.title}</span>
                    <IoIosArrowDown
                      className={`dropdown-icon ${openSubmenu === item.title ? "rotate" : ""
                        }`}
                    />
                  </div>
                  {openSubmenu === item.title && item.submenu && (
                    <ul className="submenu">
                      {item.submenu.map((subItem) => (
                        <li key={subItem.key}>
                          {subItem.submenu ? (
                            <div
                              className="submenu-item flex-container"
                              onClick={() => toggleSubSubmenu(subItem.key)}
                            >
                              <span>{subItem.label}</span>
                              <IoIosArrowDown
                                className={`dropdown-icon ${openSubSubmenu === subItem.key ? "rotate" : ""
                                  }`}
                              />
                            </div>
                          ) : (
                            <div
                              className="submenu-item flex-container"
                              onClick={() => navigationHandler(subItem.link)}
                            >
                              {subItem.label}
                            </div>
                          )}
                          {openSubSubmenu === subItem.key && subItem.submenu && (
                            <ul className="sub-submenu">
                              {subItem.submenu.map((child) => (
                                <li
                                  key={child.key}
                                  onClick={() => navigationHandler(child.link)}
                                >
                                  {child.label}
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : item.title === "PAYMENT PLANS" ? (
                <a href={item.link}>{item.title}</a>
              ) : (
                <span onClick={() => navigationHandler(item.link)}>{item.title}</span>
              )}
            </li>
          ))}

          {isLoggedIn === true ? (
            <li onClick={() => LogoutHandler()}>Logout</li>
          ) : (
            <li onClick={() => navigationHandler("/login")}>LOGIN</li>
          )}
        </ul>
        {isQuizOpen && <AcneQuiz onClose={onClose} />}
      </div>
    </Drawer>
  );
};

export default Sidebar;